import React from 'react';
import Icon from '../../Icons';
import { useGlobal } from '../../../contexts/Global/context';
import * as S from './styles';

function Checkbox({ ...props }) {
    const { contrastTheme } = useGlobal();
    return (
        <S.CustomCheckbox {...props}>
            {props.checked && <Icon name="done" color={contrastTheme ? '#000000' : '#FFFFFF'} size={14} />}
        </S.CustomCheckbox>
    );
}

export default Checkbox;
